
import { Button } from "@/components/ui/button";
import { Menu, X } from "lucide-react";
import { useResponsiveTouchTargets } from "@/lib/mobile-utils";

interface NavbarMobileToggleProps {
  isMenuOpen: boolean;
  setIsMenuOpen: (open: boolean) => void;
}

const NavbarMobileToggle = ({ isMenuOpen, setIsMenuOpen }: NavbarMobileToggleProps) => {
  const { iconButtonLarge, touchFeedback } = useResponsiveTouchTargets();

  const handleToggle = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <Button 
      variant="ghost" 
      size="icon" 
      className={`md:hidden relative z-50 ${iconButtonLarge} ${touchFeedback} focus-visible-enhanced`}
      onClick={handleToggle}
      aria-label={isMenuOpen ? "Fechar menu" : "Abrir menu"}
      aria-expanded={isMenuOpen}
      aria-controls="mobile-menu"
      aria-haspopup="true"
    >
      {isMenuOpen ? (
        <X className="h-6 w-6 transition-transform duration-200" />
      ) : (
        <Menu className="h-6 w-6 transition-transform duration-200" />
      )}
    </Button>
  );
};

export default NavbarMobileToggle;
